import styled from '@emotion/styled';
import { theme } from 'configs/styled';

export const StyledTag = styled('div')`
  .white {
    background: ${theme.palettes.white};
  }
  .base-tag {
    margin: 0;
    border: none;
    border-radius: 100px;
    padding: 2px 9px;
  }
  .click-able {
    cursor: pointer;
  }
  .primary {
    background: ${theme.palettes.lightViolet};
  }
  .secondary {
    background: ${theme.palettes.heather};
  }
  .info {
    background: ${theme.palettes.lightIndigo};
  }
  .warning {
    background: ${theme.palettes.lightYellow};
  }
`;
